



























import { Component, Prop, Vue } from "vue-property-decorator";
import { COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND } from "@/utils/colors";

/** What the sort menu reports: the option, and whether it runs from the largest / last down. */
export interface SortChoice {
  value: string;
  descending: boolean;
}

/**
 * A sort menu for the app bar with a direction (2026-11-02, the Mandanten list): the active option
 * shows an arrow, down for descending and up for ascending; choosing it again turns the direction
 * round, and choosing another option starts it in that option's own direction (`defaultDescending`:
 * a figure largest first, a name A to Z). The icon is lit, as FilterMenu's, while the sort is not the
 * first option in its own direction.
 */
@Component
export default class SortMenuComponent extends Vue {
  @Prop({ default: "mdi-sort-alphabetical-variant" })
  iconResource!: string;

  @Prop()
  tooltip!: string;

  @Prop({ required: true })
  options!: string[];

  @Prop({ required: true })
  getOptionName!: (value: string) => string;

  /** The direction an option starts in when it is chosen. */
  @Prop({ required: true })
  defaultDescending!: (value: string) => boolean;

  @Prop({ required: true })
  selectedValue!: string;

  @Prop({ type: Boolean, default: false })
  descending!: boolean;

  selectOption(value: string) {
    const choice: SortChoice =
      value === this.selectedValue
        ? { value, descending: !this.descending }
        : { value, descending: this.defaultDescending(value) };
    this.$emit("changed", choice);
  }

  get style(): string {
    const isDefault = this.selectedValue === this.options[0] && this.descending === this.defaultDescending(this.options[0]);
    return isDefault ? "" : `background-color: ${COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND}`;
  }
}
